module.exports = __webpack_public_path__ + "media/images/icons/new_codigos_prov-3fa4c37890643d63d9ccb2fb5cf703e9.svg";